import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames'; // 样式类合并
import { withStyles } from '@material-ui/core/styles';

import ReactLoading from 'react-loading';

import Logger from '../../Logger';
const logger = new Logger('PreviewVideo');

const styles = (theme) => ({
	root :
	{
		position      : 'relative',
		flex          : '100 100 auto',
		height        : '100%',
		width         : '100%',
		display       : 'flex',
		flexDirection : 'column',
		overflow      : 'hidden'
	},
	video :
	{
		flex               : '100 100 auto',
		height             : '100%',
		width              : '100%',
		objectFit          : 'cover',
		userSelect         : 'none',
		transitionProperty : 'opacity',
		transitionDuration : '.15s',
		backgroundColor    : 'var(--peer-video-bg-color)',
		backgroundImage    : `url(${window.app_base_path}/svg/buddy.svg)`,
		'&.isMirrored'     :
		{
			transform : 'scaleX(-1)'
		},
		'&.hidden' :
		{
			opacity            : 0,
			transitionDuration : '0s'
		},
		'&.loading' :
		{
			filter : 'blur(5px)'
		},
		'&.contain' :
		{
			objectFit       : 'contain',
			backgroundColor : 'rgba(0, 0, 0, 1)'
		}
	},
	preloading : {
		margin          : '0 auto'
	}
});

class PreviewVideo extends React.PureComponent
{
	constructor(props)
	{
		super(props);

		this.videoElement = React.createRef();

		this.state =
		{
			videoWidth  : null,
			videoHeight : null
		};

		// Latest received video track.
		// @type {MediaStreamTrack}
		this._videoTrack = null;

		// Periodic timer for showing video resolution.
		this._videoResolutionTimer = null;
	}

	render()
	{
		const {
			preloadWebcam,
			isMirrored,
			videoContain,
			videoVisible,
			classes,
		} = this.props;

		logger.debug(`视频状态: ${videoVisible} preloadWebcam: ${preloadWebcam}`);

		return (
			<div className={classes.root}>
				{preloadWebcam ?
				<ReactLoading type='bars' className={classnames(classes.preloading)}/> :
				<video
					ref={this.videoElement}
					className={classnames(classes.video, {
						hidden       : !videoVisible,
						'isMirrored' : isMirrored,
						contain      : videoContain
					})}
					autoPlay
					playsInline
					muted
					controls={false}
				/>}
			</div>
		);
	}

	componentDidMount()
	{
		const { videoTrack } = this.props;
		const { current: _videoEle } = this.videoElement;

		if (_videoEle) {
			this._setTracks(videoTrack);
		}
	}

	componentWillUnmount()
	{
		clearInterval(this._videoResolutionTimer);

		const { current: _videoEle } = this.videoElement;

		if (_videoEle)
		{
			_videoEle.oncanplay = null;
			_videoEle.onplay = null;
			_videoEle.onpause = null;

			_videoEle.srcObject = null;
			_videoEle.remove();
		}
	}

	componentDidUpdate(prevProps)
	{
		if (prevProps !== this.props)
		{
			const { videoTrack } = this.props;
			const { current: _videoEle } = this.videoElement;

			if (_videoEle) {
				this._setTracks(videoTrack);
			}
		}
	}

	_setTracks(videoTrack) {

		logger.debug('执行 _setTracks');

		if (this._videoTrack === videoTrack)
			return;

		this._videoTrack = videoTrack;

		clearInterval(this._videoResolutionTimer);
		this._hideVideoResolution();

		const { current: _videoEle } = this.videoElement;

		if (videoTrack) {

			logger.debug('videoTrack', videoTrack);

			const stream = new MediaStream();
			stream.addTrack(videoTrack);

			_videoEle.srcObject = stream;

			_videoEle.onended = () => {
				_videoEle.currentSrc = null;
				_videoEle.srcObject = null;
				_videoEle.remove();
			}

			_videoEle.oncanplay = () => this.setState({ videoCanPlay: true });

			_videoEle.play().catch((error) => {
				logger.warn('videoElement.play() [error:"%o]', error)
			});

			this._showVideoResolution();
		}
		else
		{
			_videoEle.srcObject = null;
		}
	}

	_showVideoResolution()
	{
		this._videoResolutionTimer = setInterval(() =>
		{
			const { videoWidth, videoHeight } = this.state;

			const { current: _videoEle } = this.videoElement;

			// Don't re-render if nothing changed.
			if (_videoEle) {
				if (
					_videoEle.videoWidth === videoWidth &&
					_videoEle.videoHeight === videoHeight
				)
					return;

				this.setState({
					videoWidth  : _videoEle.videoWidth,
					videoHeight : _videoEle.videoHeight
				});
			}
		}, 1000);
	}

	_hideVideoResolution()
	{
		this.setState({ videoWidth: null, videoHeight: null });
	}
}

PreviewVideo.propTypes =
{
	preloadWebcam     : PropTypes.bool.isRequired,
	isMirrored        : PropTypes.bool.isRequired,
	videoContain      : PropTypes.bool.isRequired,
	videoTrack        : PropTypes.any.isRequired,
	videoVisible      : PropTypes.bool.isRequired,
	classes           : PropTypes.object.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		preloadWebcam           : state.me.preloadWebcam
	}
}

export default connect(
	mapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.me.preloadWebcam === next.me.preloadWebcam
			);
		}
	}
)(withStyles(styles)(PreviewVideo));
